module.exports = __webpack_public_path__ + "img/home-featured-collection-2.bf58aad7.jpg";